var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "form",
    { staticClass: "user-group form-horizontal", attrs: { role: "form" } },
    [
      _c(
        "fieldset",
        [
          _c("Field", {
            attrs: {
              label: _vm.$t("ENABLED"),
              "has-tooltip": true,
              "tooltip-text": _vm.$t("ORP_FIELD_ENABLED_TT")
            },
            scopedSlots: _vm._u([
              {
                key: "element",
                fn: function() {
                  return [
                    _c("ValidationProvider", { attrs: { slim: "" } }, [
                      _c(
                        "div",
                        { staticClass: "col-sm-5 col-md-3" },
                        [
                          _c("nzToggle", {
                            on: { change: _vm.onChange },
                            model: {
                              value: _vm.formData.enabled,
                              callback: function($$v) {
                                _vm.$set(_vm.formData, "enabled", $$v)
                              },
                              expression: "formData.enabled"
                            }
                          })
                        ],
                        1
                      )
                    ])
                  ]
                },
                proxy: true
              }
            ])
          }),
          _vm._v(" "),
          _vm.isFormEnabled
            ? _c(
                "div",
                [
                  _c("Field", {
                    attrs: {
                      label: _vm.$t("INTRODUCTION"),
                      "has-tooltip": true,
                      "tooltip-text": _vm.$t("ORP_FIELD_INTRODUCTION_TT")
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "element",
                          fn: function() {
                            return [
                              _c(
                                "ValidationProvider",
                                { attrs: { rules: "required", slim: "" } },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "col-sm-8 col-md-9 col-lg-9"
                                    },
                                    [
                                      _c("textarea", {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value: _vm.formData.description,
                                            expression: "formData.description"
                                          }
                                        ],
                                        staticClass: "form-control",
                                        attrs: {
                                          type: "text",
                                          required: "true",
                                          rows: "6",
                                          columns: "50",
                                          name: "description",
                                          placeholder:
                                            "Please enter introduction text as plain text, HTML not supported..."
                                        },
                                        domProps: {
                                          value: _vm.formData.description
                                        },
                                        on: {
                                          input: [
                                            function($event) {
                                              if ($event.target.composing)
                                                return
                                              _vm.$set(
                                                _vm.formData,
                                                "description",
                                                $event.target.value
                                              )
                                            },
                                            _vm.onInput
                                          ],
                                          change: _vm.onChange
                                        }
                                      })
                                    ]
                                  )
                                ]
                              )
                            ]
                          },
                          proxy: true
                        }
                      ],
                      null,
                      false,
                      3675080026
                    )
                  }),
                  _vm._v(" "),
                  _c("Field", {
                    attrs: {
                      label: _vm.$t("ORP_FIELD_CONTACT"),
                      "has-tooltip": true,
                      "tooltip-text": _vm.$t("ORP_FIELD_CONTACT_TT")
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "element",
                          fn: function() {
                            return [
                              _c(
                                "ValidationProvider",
                                {
                                  attrs: { rules: "required|email", slim: "" }
                                },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "col-sm-5 col-md-3" },
                                    [
                                      _c("input", {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value: _vm.formData.contactEmail,
                                            expression: "formData.contactEmail"
                                          }
                                        ],
                                        staticClass: "form-control",
                                        attrs: {
                                          type: "text",
                                          required: "true"
                                        },
                                        domProps: {
                                          value: _vm.formData.contactEmail
                                        },
                                        on: {
                                          input: [
                                            function($event) {
                                              if ($event.target.composing)
                                                return
                                              _vm.$set(
                                                _vm.formData,
                                                "contactEmail",
                                                $event.target.value
                                              )
                                            },
                                            _vm.onInput
                                          ],
                                          change: _vm.onChange
                                        }
                                      })
                                    ]
                                  )
                                ]
                              )
                            ]
                          },
                          proxy: true
                        }
                      ],
                      null,
                      false,
                      1079221444
                    )
                  }),
                  _vm._v(" "),
                  _c("Field", {
                    attrs: {
                      label: _vm.$t("ORP_FIELD_HAS_TERMS"),
                      "has-tooltip": true,
                      "tooltip-text": _vm.$t("ORP_FIELD_HAS_TERMS_TT")
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "element",
                          fn: function() {
                            return [
                              _c(
                                "ValidationProvider",
                                { attrs: { slim: "" } },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "col-sm-5 col-md-3" },
                                    [
                                      _c("nzToggle", {
                                        on: { change: _vm.onChange },
                                        model: {
                                          value:
                                            _vm.formData
                                              .requireAgreementToTerms,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.formData,
                                              "requireAgreementToTerms",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "formData.requireAgreementToTerms"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ]
                              )
                            ]
                          },
                          proxy: true
                        }
                      ],
                      null,
                      false,
                      2552428269
                    )
                  }),
                  _vm._v(" "),
                  _vm.formData.requireAgreementToTerms
                    ? _c("Field", {
                        attrs: {
                          label: _vm.$t("ORP_FIELD_TERMS_IS_URL"),
                          "has-tooltip": true,
                          "tooltip-text": _vm.$t("ORP_FIELD_TERMS_IS_URL_TT")
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "element",
                              fn: function() {
                                return [
                                  _c(
                                    "ValidationProvider",
                                    { attrs: { slim: "" } },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "col-sm-5 col-md-3" },
                                        [
                                          _c("nzToggle", {
                                            on: { change: _vm.onChange },
                                            model: {
                                              value:
                                                _vm.formData
                                                  .isTermsAndConditionsURL,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.formData,
                                                  "isTermsAndConditionsURL",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "formData.isTermsAndConditionsURL"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ]
                                  )
                                ]
                              },
                              proxy: true
                            }
                          ],
                          null,
                          false,
                          2493030503
                        )
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.formData.requireAgreementToTerms &&
                  _vm.formData.isTermsAndConditionsURL
                    ? _c("Field", {
                        attrs: {
                          label: _vm.$t("ORP_FIELD_TERMS_URL"),
                          "has-tooltip": true,
                          "tooltip-text": _vm.$t("ORP_FIELD_TERMS_URL_TT")
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "element",
                              fn: function() {
                                return [
                                  _c(
                                    "ValidationProvider",
                                    { attrs: { rules: "required", slim: "" } },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "col-sm-5 col-md-3" },
                                        [
                                          _c("input", {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value:
                                                  _vm.formData
                                                    .termsAndConditions,
                                                expression:
                                                  "formData.termsAndConditions"
                                              },
                                              {
                                                name: "prefix",
                                                rawName: "v-prefix",
                                                value: "http://",
                                                expression: "'http://'"
                                              }
                                            ],
                                            staticClass: "form-control",
                                            attrs: {
                                              type: "text",
                                              required: "true"
                                            },
                                            domProps: {
                                              value:
                                                _vm.formData.termsAndConditions
                                            },
                                            on: {
                                              input: [
                                                function($event) {
                                                  if ($event.target.composing)
                                                    return
                                                  _vm.$set(
                                                    _vm.formData,
                                                    "termsAndConditions",
                                                    $event.target.value
                                                  )
                                                },
                                                _vm.onInput
                                              ],
                                              change: _vm.onChange
                                            }
                                          })
                                        ]
                                      )
                                    ]
                                  )
                                ]
                              },
                              proxy: true
                            }
                          ],
                          null,
                          false,
                          731814005
                        )
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.formData.requireAgreementToTerms &&
                  !_vm.formData.isTermsAndConditionsURL
                    ? _c("Field", {
                        attrs: {
                          label: _vm.$t("ORP_FIELD_TERMS"),
                          "has-tooltip": true,
                          "tooltip-text": _vm.$t("ORP_FIELD_TERMS_TT")
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "element",
                              fn: function() {
                                return [
                                  _c(
                                    "ValidationProvider",
                                    { attrs: { rules: "required", slim: "" } },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "col-sm-8 col-md-9 col-lg-9"
                                        },
                                        [
                                          _c("textarea", {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value:
                                                  _vm.formData
                                                    .termsAndConditions,
                                                expression:
                                                  "formData.termsAndConditions"
                                              }
                                            ],
                                            staticClass: "form-control",
                                            attrs: {
                                              type: "text",
                                              required: "true",
                                              rows: "6",
                                              columns: "50",
                                              placeholder:
                                                "Please enter Terms And Conditions in plain text..."
                                            },
                                            domProps: {
                                              value:
                                                _vm.formData.termsAndConditions
                                            },
                                            on: {
                                              input: [
                                                function($event) {
                                                  if ($event.target.composing)
                                                    return
                                                  _vm.$set(
                                                    _vm.formData,
                                                    "termsAndConditions",
                                                    $event.target.value
                                                  )
                                                },
                                                _vm.onInput
                                              ],
                                              change: _vm.onChange
                                            }
                                          })
                                        ]
                                      )
                                    ]
                                  )
                                ]
                              },
                              proxy: true
                            }
                          ],
                          null,
                          false,
                          2021174297
                        )
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.formData.url
                    ? _c("Field", {
                        attrs: {
                          label: _vm.$t("ORP_URL"),
                          "has-tooltip": true,
                          "tooltip-text": _vm.$t("ORP_URL_TT")
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "element",
                              fn: function() {
                                return [
                                  _c(
                                    "ValidationProvider",
                                    { attrs: { slim: "" } },
                                    [
                                      _c(
                                        "TruncatedTextCopy",
                                        {
                                          attrs: {
                                            "copy-text": _vm.formData.url
                                          }
                                        },
                                        [
                                          _c(
                                            "a",
                                            {
                                              staticClass: "prp_url",
                                              attrs: {
                                                href: _vm.formData.url,
                                                target: "_blank"
                                              }
                                            },
                                            [
                                              _vm._v(
                                                "\n                " +
                                                  _vm._s(_vm.formData.url) +
                                                  "\n              "
                                              )
                                            ]
                                          )
                                        ]
                                      )
                                    ],
                                    1
                                  )
                                ]
                              },
                              proxy: true
                            }
                          ],
                          null,
                          false,
                          793089489
                        )
                      })
                    : _vm._e()
                ],
                1
              )
            : _vm._e()
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }